module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.b8695cc1.eot";